// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"c717fd9c","256":"4d416cb1","288":"79678f41","294":"00690c3d","384":"f67f8210","387":"4f89617e","587":"463fb719","604":"4c75a460","674":"d4200a5c","735":"64bdbf2a"}[chunkId] + ".chunk.js";
};